module.exports = __webpack_public_path__ + "img/tablet_white.bef7d873.svg";